import File from "./File";
import { formatDate } from "../utils/format-utils";

export default class AARAssessment {
  aarAssessmentId: number | null;
  dateOfService: Date | null;
  aarLocation?: string | null;
  fileId?: number | null;
  file?: File | null;
  public constructor(params: AARAssessment = {} as AARAssessment) {
    let {
      aarAssessmentId = 0,
      dateOfService = null,
      aarLocation = null,
      fileId = null,
      file = null,
    } = params;
    this.aarAssessmentId = aarAssessmentId;
    this.dateOfService = dateOfService && new Date(dateOfService);
    this.aarLocation = aarLocation;
    this.fileId = fileId;
    this.file = file && new File(file);
  }
  get formattedDateOfService() {
    return formatDate(this.dateOfService);
  }
  get groupHeader() {
    var date =
      this.dateOfService && new Date(this.dateOfService).setHours(0, 0, 0, 0);
    return `${date} - ${this.aarLocation}`;
  }
}
